import 'lazysizes';
import 'lazysizes/plugins/unveilhooks/ls.unveilhooks';

window.lazySizesConfig = window.lazySizesConfig || {};
window.lazySizesConfig.expFactor = 2;
window.lazySizesConfig.init = false;

window.addEventListener('load', window.lazySizes.init);
